import script from "./dataset_tag.vue?vue&type=script&setup=true&lang=js"
export * from "./dataset_tag.vue?vue&type=script&setup=true&lang=js"

import "./dataset_tag.vue?vue&type=style&index=0&id=d4e0f172&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4e0f172"]])

export default __exports__